export enum UserRole {
  DellAdminUser = 'DellAdminUser',
  DellUser = 'DellUser',
}
